module.exports = __webpack_public_path__ + "img/sigh.b5112736.png";